<template>
  <div>
    <h3 class="pa-name">99 Property Management</h3>

    <div class="px-3 pb-1">
      <div class="teamgrid-social">
        <ul>
          <li>
            <a
              href="https://www.facebook.com/rent99pm/"
              class="f-cl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fa-brands fa-facebook"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@realtorravithota"
              class="y-cl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fa-brands fa-youtube"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/realtorravi/"
              class="i-cl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fa-brands fa-instagram"></i>
            </a>
          </li>
          <li>
            <a
              href="https://wa.me/+15062333999"
              class="l-cl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fa-brands fa-whatsapp"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
